import { useContext, useEffect, useState, useCallback } from "react";

import { DatabaseContext } from "./filrebase";

const useTile = (roomId, tileId) => {
  const db = useContext(DatabaseContext);
  const [{ loading, data, error }, setState] = useState({
    data: null,
    loading: false,
    error: null,
  });
  useEffect(() => {
    setState({ loading: true });
    return db.ref(`/rooms/${roomId}/tiles/${tileId}`).on(
      "value",
      (data) => {
        if (data) {
          setState({ loading: false, data: data.val(), error: null });
        }
      },
      (error) => {
        setState({ loading: false, data, error });
      }
    );
  }, []);

  return { data, loading, error };
};

const getSlice = (db, roomId, tileId, kind, cb) => {
  const url = `/rooms/${roomId}/tiles/${tileId}/slices/${kind}`;
  const ref = db.ref(url);
  const onValue = (snapshot) => {
    if (snapshot) {
      cb(null, snapshot.val());
    }
  };
  ref.on("value", onValue, (error) => {
    cb(error, null);
  });
  const off = () => {
    ref.off("value", onValue);
  };
  return off;
};

const useGetSlice = (db, roomId, tileId, myKind, theirKind, onSliceLoaded) => {
  useEffect(() => {
    if (tileId) {
      return getSlice(
        db,
        roomId,
        tileId,
        theirKind,
        (err, data) => data && onSliceLoaded(data, myKind)
      );
    }
  }, [db, roomId, tileId, myKind, theirKind, onSliceLoaded]);
};
const useSlices = (roomId, tile) => {
  const {
    top,
    bottom,
    left,
    right,
    topLeft,
    topRight,
    bottomLeft,
    bottomRight,
  } = tile || {};
  const db = useContext(DatabaseContext);
  const [{ loading, data, error }, setState] = useState({
    data: {},
    loading: false,
    error: null,
  });
  const onSliceLoaded = useCallback(
    (slice, kind) => {
      console.log("onSliceLoaded", slice, kind);
      setState((s) => ({ ...s, data: { ...s.data, [kind]: slice } }));
    },
    [setState]
  );

  useGetSlice(db, roomId, top, "top", "bottom", onSliceLoaded);
  useGetSlice(db, roomId, bottom, "bottom", "top", onSliceLoaded);
  useGetSlice(db, roomId, left, "left", "right", onSliceLoaded);
  useGetSlice(db, roomId, right, "right", "left", onSliceLoaded);
  useGetSlice(db, roomId, topLeft, "topLeft", "bottomRight", onSliceLoaded);
  useGetSlice(db, roomId, topRight, "topRight", "bottomLeft", onSliceLoaded);
  useGetSlice(db, roomId, bottomLeft, "bottomLeft", "topRight", onSliceLoaded);
  useGetSlice(db, roomId, bottomRight, "bottomRight", "topLeft", onSliceLoaded);

  return { data, loading, error };
};

const useTileSlice = (roomId, tileId, kind) => {
  const db = useContext(DatabaseContext);
  const [{ loading, data, error }, setState] = useState({
    data: null,
    loading: false,
    error: null,
  });
  useEffect(() => {
    const ref = `/rooms/${roomId}/tiles/${tileId}/slices/${kind}`;
    setState({ loading: true });
    return db.ref(ref).on(
      "value",
      (data) => {
        if (data) {
          setState({ loading: false, data: data.val(), error: null });
        }
      },
      (error) => {
        setState({ loading: false, data, error });
      }
    );
  }, []);

  return { data, loading, error };
};

export { useTile, useTileSlice, useSlices };
